import { ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { GlobalErrorHandler } from './providers/error-handler';
import { APP_BASE_HREF } from '@angular/common';
import { provideWindow, loaderInterceptor } from '@sfcu/sfc-front-starter';
import { provideKeycloakAngular } from './keycloak.config';
import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, includeBearerTokenInterceptor } from 'keycloak-angular';
import { apiErrorInterceptor } from './interceptors/api-error.interceptor';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*resiliation-ws.*$/i,
    bearerPrefix: 'Bearer'
});

export const appConfig: ApplicationConfig = {
    providers: [
        provideKeycloakAngular(),
        {
            provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
            useValue: [urlCondition]
        },
        provideZoneChangeDetection({ eventCoalescing: true }),
        importProvidersFrom(BrowserModule, FormsModule),
        provideRouter(routes),
        provideHttpClient(
            withInterceptors([includeBearerTokenInterceptor, loaderInterceptor, apiErrorInterceptor])
        ),
        provideWindow(),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        {
            provide: APP_BASE_HREF,
            useValue: window.location.origin.includes('localhost')
                ? '/'
                : '/resiliation'
        },
    ]
};
